/**
 * Lebensrad auf der Uebersicht (V-07) - nur zum Anschauen (V-02). Die
 * vorige Bewertung steht blass dahinter; ein Klick fuehrt zum Bewerten in
 * die Monatsreflexion.
 */
import { useLiveQuery } from 'dexie-react-hooks';
import { Link } from 'react-router-dom';

import { RadarChart } from '@/modules/lifewheel/components/RadarChart';
import { useAreas } from '@/modules/areas/useAreas';
import { db } from '@/db/schema';
import { monatKey } from '@/domain/review/periods';
import { formatDate, today } from '@/lib/datetime';
import type { LifeWheelSnapshot } from '@/domain/types';

export function LebensradAnzeige() {
  const areas = useAreas().filter((a) => a.lifeWheelEnabled);
  const letzte = useLiveQuery(() => db.lifeWheel.orderBy('date').reverse().limit(2).toArray(), [], [] as LifeWheelSnapshot[]);
  const [stand, vorher] = letzte;
  const ziel = `/rueckblick?monat=${monatKey(today())}`;

  if (areas.length === 0) return null;
  if (!stand) {
    return <Link to={ziel} className="text-[12px] text-ink-faint hover:text-ink hover:underline">Lebensrad noch nicht bewertet – in der Monatsreflexion bewerten</Link>;
  }
  return (
    <Link to={ziel} aria-label={`Lebensrad, Stand ${formatDate(stand.date)} – im Rückblick bewerten`} className="flex flex-col items-center gap-1 rounded-md hover:bg-surface-raised/50">
      <div className="w-full max-w-72">
        <RadarChart
          axes={areas.map((a) => ({ id: a.id, name: a.name, color: a.color, value: stand.scores[a.id] ?? 0 }))}
          compare={vorher ? areas.map((a) => vorher.scores[a.id] ?? 0) : undefined}
        />
      </div>
      <span className="text-[11px] text-ink-faint">Stand {formatDate(stand.date)}{vorher ? ` · gestrichelt: ${formatDate(vorher.date)}` : ''}</span>
    </Link>
  );
}
